import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import { connect } from "react-redux";
import { IconButton, Tooltip } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import PeriodComponent from "../HeaderComponent/PeriodComponent";
import { CALENDAR_TYPES } from "../../store/helpers/constantVariables";
import PeriodSelection from "./PeriodSelection";

const styles = theme => ({
  container: {
    display: "flex",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    alignItems: "baseline",
    justifyContent: "flex-start",
    position: "sticky",
    left: 10,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: 150
  },
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1) * 2,
    width: 150,
    height: 40
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 100
  }
});

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      textFilter: props.textFilter
    };
  }

  componentDidMount() {
    this.timer = null;
  }

  onTextChangeHandler = event => {
    clearTimeout(this.timer);

    this.setState({ textFilter: event.target.value });

    this.timer = setTimeout(this.triggerChange.bind(this), 1000);
  };

  triggerChange() {
    this.props.onTextFilterChange(this.state.textFilter);
  }

  onCustomDateSelectedHandler = () => {
    this.props.setPeriodDataHandle({});

    this.props.onSetCalendarType(CALENDAR_TYPES.PERIOD);
  };

  onFiltersReset() {
    this.setState({ textFilter: "" });
    this.props.onFiltersReset();
  }

  render() {
    const { classes } = this.props;
    const carBrands = [];
    const carModels = [];
    const carFuelTypes = [];
    const carGearboxes = [];

    this.props.cars.forEach(car => {
      if (!carBrands.includes(car.marka)) {
        carBrands.push(car.marka);
      }
    });
    const carBrandsSelects = carBrands.map(brand => {
      return (
        <MenuItem key={brand} value={brand}>
          {brand}
        </MenuItem>
      );
    });
    this.props.cars.forEach(car => {
      if (!carModels.includes(car.model)) {
        if (
          this.props.brandSelected === "" ||
          this.props.brandSelected === car.marka
        ) {
          carModels.push(car.model);
        }
      }
    });
    const carModelsSelects = carModels.map(model => {
      return (
        <MenuItem key={model} value={model}>
          {model}
        </MenuItem>
      );
    });
    this.props.cars.forEach(car => {
      if (!carGearboxes.includes(car.skrzynia_biegow)) {
          carGearboxes.push(car.skrzynia_biegow);
      }
    });
    const carGearboxOptions = carGearboxes.map(gearbox => {
      return (
        <MenuItem key={gearbox} value={gearbox}>
          {gearbox}
        </MenuItem>
      );
    });
    this.props.cars.forEach(car => {
      if (!carFuelTypes.includes(car.rodz_paliwo)) {
        carFuelTypes.push(car.rodz_paliwo);
      }
    });
    const carFuelTypesOptions = carFuelTypes.map(fuelType => {
      return (
        <MenuItem key={fuelType} value={fuelType}>
          {fuelType}
        </MenuItem>
      );
    });

    return (
      <form className={classes.container} onKeyUp={this.onKeyUpHandler}>
        <TextField
          className={classes.textField}
          label="Wyszukaj"
          type="text"
          value={this.state.textFilter}
          onInput={this.onTextChangeHandler}
        />
        <FormControl className={classes.formControl}>
          <InputLabel>Paliwo</InputLabel>
          <Select
            onChange={this.props.onFuelFilterChange}
            value={this.props.fuelFilter}
          >
            <MenuItem value="">Wszystkie</MenuItem>
            {carFuelTypesOptions}
          </Select>
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel>Marka</InputLabel>
          <Select
            value={this.props.brandSelected}
            onChange={this.props.onBrandFilterChange}
          >
            <MenuItem value="">Wszystkie</MenuItem>
            {carBrandsSelects}
          </Select>
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel>Model</InputLabel>
          <Select
            onChange={this.props.onModelFilterChange}
            value={this.props.modelSelected}
          >
            <MenuItem value="">Wszystkie</MenuItem>
            {carModelsSelects}
          </Select>
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel>Skrzynia</InputLabel>
          <Select
            value={this.props.gearboxSelected}
            onChange={this.props.onGearboxFilterChange}
          >
            <MenuItem value="">Wszystkie</MenuItem>
            {carGearboxOptions}
          </Select>
        </FormControl>
        <PeriodComponent />
        <PeriodSelection />

        <Tooltip
          arrow={true}
          placement="top"
          title="Resetuj filtry"
        >
          <IconButton
            onClick={this.onFiltersReset.bind(this)}
          >
            <CachedIcon />
          </IconButton>
        </Tooltip>
      </form>
    );
  }
}

const mapStateToProps = state => {
  return {
    cars: state.formReducer.cars,
    periodStartDate: state.formReducer.periodStartDate,
    periodDaysCount: state.formReducer.periodDaysCount,
    periodEndDate: state.formReducer.periodEndDate,
    calendarType: state.formReducer.calendarType
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPeriodDataHandle: value =>
      dispatch({ type: "SET_PERIOD_DATA", value: value }),
    onSetCalendarType: value =>
      dispatch({ type: "SET_CALENDAR_TYPE", calendarType: value })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Filters));
